import axios from 'axios';
import { clearAllCookies, clearItem, getItem } from '../view/Utils/CommonFunction/CommonFunction';
import { DOWNLOAD_SAMPLE_FILE } from '../common/config';

const prepareHeaders = () => {
  let accessToken = getItem('accessToken');
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };
};

export const samplefileService = async (payload) => {
  try {
    const response = await axios({
      method: 'GET',
      url: `${DOWNLOAD_SAMPLE_FILE}`,
      headers: prepareHeaders().headers,
      params: payload,
    });
    return response;
  } catch (e) {
    if (e?.response?.status == 401) {
      window.location.reload()
      clearAllCookies();
      clearItem();
    }
    return e;
  }
};
